<template>
    <div class="twin-form-box">
        <input-field v-for="(field,index) in options.fields" :key="index"
                       :value="getVal(index)"
                       @input="inputHandler($event,index)"
                       :type="field.type"
                       :options="field.options"
                       :id="getInputId(index)"
                       :label="field.label"
                       :clone="field.clone"
                       :hint="field.hint"
                       class="small-size"
        ></input-field>
    </div>
</template>

<script>
    //import InputField from "./InputField";

    //import InputField from "./InputField";
    export default {
        name: 'group-field',
        components: {
            //InputField,
            InputField: () => import( "./InputField")
            //FieldWrapper: () => import( "./FieldWrapper")
        },
        props: {
            id: [Number, String],
            value: Object,
            options: Object
        },
        data() {
            return {
                type: 'text',
            }
        },
        methods: {
            getVal(index) {
                if (this.value === undefined) {
                    return null
                }
                return this.value.values !== undefined ? this.value.values[index] : null
            },
            inputHandler(e,index) {
                let newValue = this.value;
                if(newValue === undefined || newValue.values === undefined) {
                    newValue = {values: []};
                }
                //newValue.values[index]= e;
                newValue.values.splice(index, 1, e);
                this.$emit('input', newValue)
            },
            getInputId(index) {
                let id = 'group-' + this.options.fields[index].id;
                if (this.clone) {
                    id = id + '-' + index;
                }
                return id
            },
        },
        beforeCreate() {

        },
        created() {
            if(this.value === undefined || this.value.values === undefined) {
                this.$emit('input', {values: []});
            }
        },


    }
</script>


<style scoped>

</style>
